// extracted by mini-css-extract-plugin
export default {"mint":"Minting_mint__xOTzk","amount":"Minting_amount__2iG-3","cost":"Minting_cost__M5nQW","value":"Minting_value__qcO12"};